// Printable 80 mm receipt for a bar ticket — opens a print window with hotel header, items, VAT split, invoice & EFI codes.
import { apiCall } from '../_shared';

const esc = (s) => String(s ?? '').replace(/[&<>"]/g, (c) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]));
const eur = (n) => `€${Number(n || 0).toFixed(2)}`;
const PAY = { cash: 'Cash', card: 'Card', room: 'Charged to room' };

export const receiptHtml = ({ ticket: t, hotel: h, invoice: inv }) => {
  const lines = (t.lines || []).map((l) => `<tr><td>${l.qty}× ${esc(l.name)}</td><td class="r">${eur(l.qty * l.price)}</td></tr>`).join('');
  const grossByRate = {};
  (t.lines || []).forEach((l) => { const k = String(Math.round(Number(l.vat_rate || 0) * 100)).padStart(2, '0'); grossByRate[k] = (grossByRate[k] || 0) + l.qty * l.price; });
  const vat = Object.entries(t.vat_breakdown || {}).map(([k, amt]) => `<tr><td>VAT ${Number(k)}% (net ${eur((grossByRate[k] || 0) - Number(amt || 0))})</td><td class="r">${eur(amt)}</td></tr>`).join('');
  const when = new Date(t.at).toLocaleString('en-GB', { day: '2-digit', month: '2-digit', year: 'numeric', hour: '2-digit', minute: '2-digit' });
  const fiscal = inv ? `
    <div class="box">
      <div><b>Invoice ${esc(inv.number)}</b></div>
      ${inv.fiscal_status === 'fiscalized' ? `<div>IKOF: ${esc(inv.iic)}</div><div>JIKR: ${esc(inv.fic)}</div>${inv.business_unit ? `<div>BU ${esc(inv.business_unit)} · TCR ${esc(inv.tcr)} · OP ${esc(inv.operator)}</div>` : ''}${inv.verify_url ? `<div class="small">${esc(inv.verify_url)}</div>` : ''}`
        : `<div class="small">Fiscalization: ${esc(inv.fiscal_status === 'not_configured' ? 'pending — EFI not configured' : inv.fiscal_status || 'pending')}</div>`}
    </div>` : `<div class="box"><div><b>Charged to room</b> — ${esc(t.room_name || '')}${t.guest_name ? ` · ${esc(t.guest_name)}` : ''}</div><div class="small">Settled with the room bill at check-out.</div></div>`;
  return `<!doctype html><html><head><meta charset="utf-8"><title>Bar receipt #${t.number}</title>
  <style>
    @page { size: 80mm auto; margin: 4mm; }
    body { font-family: "Courier New", monospace; font-size: 12px; width: 72mm; margin: 0 auto; color: #000; }
    h1 { font-size: 15px; text-align: center; margin: 0 0 2px; }
    .c { text-align: center; } .r { text-align: right; white-space: nowrap; } .small { font-size: 10px; word-break: break-all; }
    table { width: 100%; border-collapse: collapse; } td { padding: 1px 0; vertical-align: top; }
    hr { border: 0; border-top: 1px dashed #000; margin: 6px 0; }
    .tot td { font-weight: bold; font-size: 14px; border-top: 1px solid #000; padding-top: 4px; }
    .box { border: 1px solid #000; padding: 4px; margin-top: 6px; }
  </style></head><body>
    <h1>${esc(h.name)}</h1>
    <div class="c small">${esc(h.address)}${h.tin ? `<br/>PIB/TIN ${esc(h.tin)}` : ''}${h.phone ? `<br/>${esc(h.phone)}` : ''}</div>
    <hr/>
    <div>Bar receipt <b>#${t.number}</b> · ${when}</div>
    <div class="small">Served by ${esc(t.by)}${t.status === 'void' ? ' · <b>VOID</b>' : ''}</div>
    <hr/>
    <table>${lines}</table>
    <hr/>
    <table>${vat}<tr class="tot"><td>TOTAL</td><td class="r">${eur(t.total)}</td></tr><tr><td>Paid by</td><td class="r">${PAY[t.payment] || esc(t.payment)}</td></tr></table>
    ${fiscal}
    <hr/>
    <div class="c small">Prices include VAT. Thank you — hvala — faleminderit.</div>
    <script>window.onload = function(){ setTimeout(function(){ window.print(); }, 150); };</script>
  </body></html>`;
};

export const printReceipt = async (ticketId) => {
  const data = await apiCall(`/api/admin/bar/tickets/${ticketId}/receipt`);
  const w = window.open('', '_blank', 'width=420,height=720');
  if (!w) throw new Error('Pop-up blocked — allow pop-ups to print receipts');
  w.document.open();
  w.document.write(receiptHtml(data));
  w.document.close();
  return data;
};
